import { ComposerMediaContext, FileUploadState } from 'components/ComposerMediaContext'
import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { composerVideoSelector } from 'services/compose/selectors'

/**
 * The local video File the user picked this session, matched to the composer's current video.
 * Undefined when the video came from a URL or a saved post rather than a local upload.
 */
export function useComposerVideoUpload(): FileUploadState | undefined {
  const { files } = useContext(ComposerMediaContext)
  const video = useSelector(composerVideoSelector)

  if (!video?.id) {
    return undefined
  }

  // instanceof guards against fake file objects (e.g. `{ name }` placeholders) ever counting
  // as a local upload — downstream consumers hand `.file` to URL.createObjectURL.
  return Object.values(files).find(f => f.id === video.id && f.file instanceof File)
}
